<div class="bloco-obras-responsabilidade container-fluid">
  <div class="cards-row">

    <ng-container *ngIf="!loading; else skeleton">
      <div class="card card-green">
        <a routerLink="/obras/minhas">
          <div class="card-title" title="Mostra a lista completa de todas as obras atribuídas a você.">
            Minhas Obras
          </div>
          <span class="card-number">{{ myWorks }} obras</span>
          @if (myWorksUpdatedLast7Days > 0) {
          <span class="card-subtext">
            <mat-icon class="info-icon-gray">info</mat-icon>
            {{ myWorksUpdatedLast7Days }} obra(s) atualizada(s) nos últimos 7 dias
          </span>
          } @else {
          <span class="card-subtext">
            <mat-icon class="info-icon-gray">info</mat-icon>
            Nenhuma obra atualizada nos últimos 7 dias
          </span>
          }
        </a>
      </div>

      @if (level === 'Master') {
      <div class="card card-yellow">
        <a routerLink="/obras/equipe">
          <div class="card-title" title="Lista completa de todas as obras que estão sob responsabilidade da equipe.">
            Obras da Equipe
          </div>
          <span class="card-number">{{ teamWorks }} obras</span>
          @if (teamWorksUpdatedLast7Days > 0) {
          <span class="card-subtext">
            <mat-icon class="info-icon-gray">info</mat-icon>
            {{ teamWorksUpdatedLast7Days }} obra(s) atualizada(s) nos últimos 7 dias
          </span>
          } @else {
          <span class="card-subtext">
            <mat-icon class="info-icon-gray">info</mat-icon>
            Nenhuma obra atualizada nos últimos 7 dias
          </span>
          }
        </a>
      </div>
      }

      <div class="card card-blue">
        <a routerLink="/obras/nao-vistas">
          <div class="card-title" title="Lista das obras que estão sob sua responsabilidade e que ainda não foram acessadas.">
            Obras Ainda Não Vistas
          </div>
          <span class="card-number">{{ notSeen }} obras</span>
          @if (notSeenAddedToday > 0) {
          <span class="card-subtext">
            <mat-icon class="info-icon-gray">info</mat-icon>
            {{ notSeenAddedToday }} obra(s) adicionada(s) hoje
          </span>
          } @else {
          <span class="card-subtext">
            <mat-icon class="info-icon-gray">info</mat-icon>
            Nenhuma obra adicionada hoje
          </span>
          }
        </a>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #skeleton>
  <div class="cards-row">
    <div class="card skeleton-card"></div>
    @if (level === 'Master') {
    <div class="card skeleton-card"></div>
    }
    <div class="card skeleton-card"></div>
  </div>
</ng-template>